/* Do not use _ in key */
export const STORAGE_TYPES = {
    ERROR_NOT_FOUND: 'NotFoundError',
    ERROR_EXPIRED: 'ExpiredError'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/device/types/storage.types.js